import React from "react";
import styled from "styled-components";
import { bool, func, node, number } from "prop-types";
import Button from "components/shared/Button";
import LoadingSpinner from "components/utils/LoadingSpinner";

const Wrapper = styled.div`
  height: 100%;
`;

const Page = styled.div`
  height: 100%;
`;

const ButtonContainer = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem 2rem;
`;

const PaginatedWrapper = ({
  children,
  currentPage,
  loading,
  setCurrentPage
}) => {
  const completeActionThenChangePage = (
    pageUpdateAction,
    pageChange,
    pageChangeFields
  ) => {
    if (pageUpdateAction) {
      pageUpdateAction();
    }
    setCurrentPage(pageChange, pageChangeFields);
  };

  return (
    <Wrapper>
      {children.map((page, index) => {
        const {
          backClass,
          fields,
          nextClass,
          noButtons,
          pageUpdateAction,
          submissionPage,
          submitAction,
          submitClass
        } = page.props;
        if (index + 1 === currentPage) {
          return (
            <Page key={`page-${index + 1}`}>
              {page}
              {!noButtons && (
                <ButtonContainer>
                  <Button
                    backClass={backClass}
                    background="none"
                    label="Back"
                    noAnimation
                    onClick={() =>
                      completeActionThenChangePage(
                        pageUpdateAction,
                        currentPage - 1
                      )
                    }
                    textColour="grey"
                  />
                  {!submissionPage && (
                    <Button
                      background="basicBlue"
                      label="Next"
                      nextClass={nextClass}
                      onClick={() =>
                        completeActionThenChangePage(
                          pageUpdateAction,
                          currentPage + 1,
                          fields
                        )
                      }
                      width="100px"
                    />
                  )}
                  {submissionPage && (
                    <Button
                      background="basicBlue"
                      label={loading ? <LoadingSpinner /> : "Send"}
                      onClick={submitAction}
                      submitClass={submitClass}
                      width="100px"
                    />
                  )}
                </ButtonContainer>
              )}
            </Page>
          );
        }
        return null;
      })}
    </Wrapper>
  );
};

PaginatedWrapper.propTypes = {
  children: node.isRequired,
  currentPage: number.isRequired,
  loading: bool,
  setCurrentPage: func.isRequired
};

export default PaginatedWrapper;
